 <template>
  <div class="nameCard-box">
    <!-- <Header :title="title"></Header> -->
    <div :class="gender=='女'?'content content-girl':'content-man content'" ref="imageWrapper">
      <div class="d-title">
        <div class="tit-left">
          <div class="d-t-sty">
            <div
              :class="gender=='女'?'t-sty-name ':'t-sty-name-man t-sty-name'"
            >{{ form.username ? form.username : form.nickName}}</div>
            <div
              :class="gender=='女'?'bottom-border ':'bottom-border-man bottom-border'"
              class="bottom-border"
            ></div>
            <!-- <div class="t-sty-address">{{ form.city }}</div> -->
          </div>
          <div :class="gender=='女'?'t-motto t-motto-girl':'t-motto t-motto-man'">
            <div :class="gender=='女'?'t-introduction ':'t-introduction t-introduction-man'">
              <div>个人简介</div>
              <svg-icon v-if="gender=='女'" icon-class="name-card-icon"></svg-icon>
              <svg-icon v-else icon-class="name-card-icon1"></svg-icon>
            </div>
            <div class="intro-con">{{ form.profiles }}</div>
          </div>
          <div class="round-img">
            <img src="./img/round.png" alt />
          </div>
          <div
            :class="gender=='女'?'t-motto t-motto1 t-motto-girl':'t-motto t-motto1 t-motto-man'"
          >{{ form.motto }}</div>
        </div>
        <div class="tit-right">
          <img :src="bodyImg" alt="">
        </div>
      </div>
      <div class="qrcode-code">
        <qrcode :staffId="staffId" :avatarName="form.avatarName"></qrcode>
        <div :class="gender=='女'?'t-phone t-motto-girl':'t-phone t-phone-man'">Tel：{{ form.phone }}</div>
      </div>
    </div>
    <div class="details-bot">
      <div class="bot-dis">
        <div class="dis-left com-dis">
          <van-icon name="share-o" />
          <div class="bot-text copy-btn" id="companyName" @click.prevent="upShare">分享</div>
        </div>
        <div class="dis-right com-dis">
          <van-icon name="contact" />
          <div class="bot-text" @click.prevent="goUserInfo">个人信息</div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPop" close-icon-position="top-left" :closeable="true">
      <div>
        <div class="pop-title">长按图片保存</div>
        <img :src="imgUrl" alt class="cv-img" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
// import Header from "@/components/header.vue";
import utils from '@/utils/utils'
import html2canvas from 'html2canvas'
import Qrcode from './qrcode.vue';
import URL from '@/api/api'
export default {
  components: {
    // Header,
    Qrcode,
  },
  data() {
    return {
      title: "个人名片",
      active: 0,
      value: 8.8,
      flg: 0,
      isShow: false,
      popShow: true,
      showPop: false,
      staffId: null,
      imgUrl: '',
      form: {},
      bodyImg: '',
      width: `${document.documentElement.clientWidth}px`,
      height: `${document.documentElement.clientWidth * 1.777}px`,
      gender: null
    };
  },
  mounted() {
    this.flg = this.$route.query.flg;
    this.getdata();
  },
  methods: {
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    getdata() {//get获取个人信息\ post编辑个人信息
      let id =this.getUrlParams('userid')?this.getUrlParams('userid'):localStorage.getItem('userid')
      this.$fetchGet(URL.getStaffsCard.url, { userId: id }).then((res) => {
        this.form = res.data.data
        this.staffId = this.form.id
        this.gender = this.form.gender
        if (this.form.status == '1') {
          Toast('个人照片审核中')
        } else if (this.form.status == '9') {
          Toast('个人照片未通过审核')
        }
        if (this.form.bodyImg && this.form.status == '2') {
          this.bodyImg = this.form.bodyImg
        } else {
          if (this.gender == '女') {
            this.bodyImg = require('./img/wImg.png')
          } else {
            this.bodyImg = require('./img/mImg.png')
          }
        }
      });
    },
    go() {
      this.$router.go(-1);
    },

    goUserInfo() {
      this.$router.push('/personalInfo')
    },
    upShare() {
      let that = this
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 禁止背景点击
        duration: 0 // 持续展示
      })
      var opts = {
        useCORS: true, // 【重要】开启跨域配置
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
        scrollX: 0,
        height: that.$refs.imageWrapper.offsetHeight,
        width: that.$refs.imageWrapper.offsetWidth,
        scale: 8,
        dpi: window.devicePixelRatio * 2,
        // backgroundColor: 'null',
      };
      setTimeout(() => {
        html2canvas(that.$refs.imageWrapper, opts).then(canvas => {
          // todo png格式安卓保存失败
          that.showPop = true
          that.imgUrl = canvas.toDataURL("image/jpeg",1.0);
          Toast.clear()
        });

      }, 1000)
    }
  },
};
</script>
<style lang="less" scoped>
.content-man {
  background: url("./img/bag-m.png") 100% no-repeat;
}
.content-girl {
  background: url("./img/bag.jpg") 100% no-repeat;
}
.content {
  width: 375.5px;
  height: 560px;
  background-size: 100% 100%;
  position: relative;
  .qrcode-code {
    display: flex;
    margin: 0 0 0 15px;
    padding-bottom: 10px;
    .t-phone {
      margin: 47px 0 0 78px;
      color: #d28f00;
      font-size: 15px;
      font-weight: bold;
    }
    .t-phone-man {
      color: #563100;
    }
  }
  .d-title {
    width: 375.5px;
    display: flex;
    .tit-left {
      width: 159px;
      min-height: 400px;
      margin: 80px 0 0 40px;
      .round-img {
        width: 47px;
        margin-top: 30px;
      }
      .round-img img {
        width: 100%;
      }
      .t-motto-man {
        color: #ffdebd;
      }
      .t-motto-girl {
        color: #241200;
      }
      .t-motto {
        width: 144px;
        margin-top: 30px;
        font-size: 10.5px;
        color: #333333;
        font-family: SourceHanSansCN-Regular;
        .t-introduction {
          display: flex;
          font-size: 15px;
          font-weight: bold;
          color: #d28f00;
          .svg-icon {
            width: 8.5px;
            height: 8.5px;
            margin-left: 4px;
          }
        }
        .t-introduction-man {
          color: #563100;
        }
        .intro-con {
          margin-top: 12px;
          text-align: justify;
        }
      }
      .t-motto1 {
        margin-top: 17.5px;
      }
    }
    .tit-right {
      width: 155px;
      max-height: 390px;
      margin-top: 90px;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
    .d-t-sty {
      // display: flex;
      .use-score {
        padding: 0 5px;
      }
    }
    .t-sty-name {
      // width: 62.5px;
      height: 42px;
      font-size: 30px;
      color: #d28f00;
      font-weight: bold;
    }
    .t-sty-name-man {
      color: #563100;
    }
    .bottom-border {
      width: 40.5px;
      height: 2.5px;
      margin-top: 10.5px;
      margin-left: 11.5px;
      background: #d28f00;
      text-align: center;
    }
    .bottom-border-man {
      background: #563100;
    }
    // .t-sty-address {
    //   margin: 10px 0 0 10px;
    // }
  }
  .d-text-sty {
    margin: 0 0 80px 0;
    padding: 0px 15px;
    line-height: 1.5;
    background: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .d-introduce {
      font-size: 20px;
      padding: 20px 0;
    }
    .d-int {
      padding-bottom: 10px;
      border-bottom: 1px solid #ebedf0;
    }
  }
  .vau-name {
    font-size: 20px;
  }
  .flg0-title {
    font-size: 20px;
  }
}
.details-bot {
  background: #7d1a25;
  color: #fff;
  width: 80%;
  border-radius: 25px;
  padding: 10px;
  margin: auto; 
  position: fixed;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  .bot-dis {
    display: flex;
    justify-content: space-around;
    font-size: 20px;
  }
  .com-dis {
    display: flex;
    width: 40%;
    justify-content: center;
    align-items: center;
  }
  .bot-text {
    padding-left: 10px;
    a {
      color: #fff;
    }
  }
}
.dia-message {
  width: 80%;
  margin: 25px auto;
  text-align: center;
}
.dia-title {
  font-weight: bold;
}
.van-popup {
  width: 100%;
  height: 100%;
  .pop-title {
    padding: 15px;
    text-align: center;
    font-size: 15px;
  }
  .cv-img {
    width: 100%;
  }
}
</style>
